import { render, staticRenderFns } from "./ButtonTextBelow.vue?vue&type=template&id=1d43edb9&scoped=true&"
import script from "./ButtonTextBelow.vue?vue&type=script&lang=ts&"
export * from "./ButtonTextBelow.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonTextBelow.vue?vue&type=style&index=0&id=1d43edb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d43edb9",
  null
  
)

export default component.exports